import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { supabase } from "@/lib/supabase";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    // Toujours afficher le même message, que l'adresse existe ou non :
    // ne pas révéler quels emails ont un compte.
    await supabase.auth.resetPasswordForEmail(email.trim(), { redirectTo: `${location.origin}/` });
    setBusy(false); setSent(true);
  }

  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      <div className="glass-strong w-full max-w-sm rounded-3xl p-8">
        <div className="mb-6 text-center">
          <div className="mx-auto mb-3 grid h-12 w-12 place-items-center rounded-2xl text-lg font-black text-white" style={{ background: "var(--gradient-primary)" }}>IC</div>
          <div className="font-heading text-2xl font-extrabold tracking-tight">IRONCLIC</div>
          <div className="mt-1 text-sm text-muted-foreground">Mot de passe oublié</div>
        </div>
        {sent ? (
          <p className="text-sm">Si un compte existe pour <strong>{email}</strong>, un email vient de partir avec un lien pour choisir un nouveau mot de passe. Le lien est valable une heure.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <Button type="submit" className="w-full" disabled={busy}>Envoyer le lien</Button>
          </form>
        )}
        <p className="mt-6 text-center text-sm"><Link to="/connexion" className="text-muted-foreground hover:text-foreground">← Retour à la connexion</Link></p>
      </div>
    </div>
  );
}
